import React, { Component } from "react"
import TableProrrogacaoContratual from "./TableProrrogacaoContratual"
import Layout from "../../Layout"
import { Loading, HttpError } from "../../../components"
import * as ApiHelper from "../../../ApiHelper"
import Moment from "moment"
export default class ProrrogacaoContratual extends Component {
  constructor() {
    super()
    this.getProrrogacao = this.getProrrogacao.bind(this)
    this.didDelete = this.didDelete.bind(this)
    this.filter = this.filter.bind(this)
    this.state = { prorrogacoes: [], initialProrrogacoes: [], showTable: false }
  }
  componentWillMount() {
    this.getProrrogacao()
  }
  getProrrogacao() {
    ApiHelper.getProrrogacaoContratual((prorrogacoes, error) => {
      if (prorrogacoes) {
        this.setState({
          prorrogacoes: prorrogacoes,
          initialProrrogacoes: prorrogacoes,
          showTable: true
        })
      } else {
        this.setState({
          httpError: error
        })
      }
    })
  }
  filter(event) {
    var searchText = event.target.value.toLowerCase()
    var filtered = this.state.initialProrrogacoes.filter(prorrogacao => {
      return (
        Moment(prorrogacao.created_at)
          .format("D/MM/Y")
          .toLowerCase()
          .search(searchText) !== -1 ||
        prorrogacao.razao.toLowerCase().search(searchText) !== -1 ||
        prorrogacao.contrato.num_contrato.toLowerCase().search(searchText) !==
          -1
      )
    })
    this.setState({
      prorrogacoes: filtered
    })
  }
  didDelete() {
    this.getProrrogacao()
  }
  render() {
    if (this.state.httpError) {
      return (
        <Layout tabActive="Fiscalização">
          <HttpError
            message={this.state.httpError.message}
            status={this.state.httpError.status}
          />
        </Layout>
      )
    }
    return (
      <Layout tabActive="Fiscalização">
        {this.state.showTable ? (
          <TableProrrogacaoContratual
            filter={this.filter}
            onDelete={this.didDelete}
            sizeClass=""
            title={"Prorrogações contratuais"}
            subtitle={"Listagem das prorrogações contratuais criadas"}
            backgroundColor="as-blue"
            rows={this.state.prorrogacoes}
          />
        ) : (
          <Loading />
        )}
      </Layout>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/prorrogacao-contratual/ProrrogacaoContratual.js